import type { ReactNode } from 'react';
import styles from './CdLanguageSelect.module.scss';

/** Five-point star, starting at the top. */
const star = (cx: number, cy: number, outer: number, inner: number) =>
  Array.from({ length: 10 }, (_, index) => {
    const radius = index % 2 === 0 ? outer : inner;
    const angle = -Math.PI / 2 + (index * Math.PI) / 5;
    return `${(cx + Math.cos(angle) * radius).toFixed(2)},${(cy + Math.sin(angle) * radius).toFixed(2)}`;
  }).join(' ');

const flags: Record<string, ReactNode> = {
  en: (
    <>
      <rect width="20" height="14" fill="#bf0a30" />
      <rect y="2" width="20" height="2" fill="#fff" />
      <rect y="6" width="20" height="2" fill="#fff" />
      <rect y="10" width="20" height="2" fill="#fff" />
      <rect width="9" height="8" fill="#002868" />
    </>
  ),
  am: (
    <>
      <rect width="20" height="4.67" fill="#078930" />
      <rect y="4.67" width="20" height="4.66" fill="#fcdd09" />
      <rect y="9.33" width="20" height="4.67" fill="#da121a" />
      <circle cx="10" cy="7" r="2.1" fill="#0f47af" />
    </>
  ),
  es: (
    <>
      <rect width="20" height="14" fill="#c60b1e" />
      <rect y="3.5" width="20" height="7" fill="#ffc400" />
    </>
  ),
  fr: (
    <>
      <rect width="6.67" height="14" fill="#002395" />
      <rect x="6.67" width="6.66" height="14" fill="#fff" />
      <rect x="13.33" width="6.67" height="14" fill="#ed2939" />
    </>
  ),
  ko: (
    <>
      <rect width="20" height="14" fill="#fff" />
      <circle cx="10" cy="7" r="3" fill="#cd2e3a" />
      <path d="M10 4a3 3 0 0 1 0 6 1.5 1.5 0 0 1 0-3 1.5 1.5 0 0 0 0-3z" fill="#0047a0" />
    </>
  ),
  vi: (
    <>
      <rect width="20" height="14" fill="#da251d" />
      <polygon points={star(10, 7.2, 3.3, 1.3)} fill="#ff0" />
    </>
  ),
  zh: (
    <>
      <rect width="20" height="14" fill="#de2910" />
      <polygon points={star(5, 4.2, 2, 0.8)} fill="#ffde00" />
    </>
  ),
};

/** Small flag for a supported language code. Unknown codes render nothing. */
export const LanguageFlag = ({ code }: { code: string }) => {
  const body = flags[code];
  if (!body) return null;
  return (
    <svg className={styles.flag} viewBox="0 0 20 14" aria-hidden="true">
      {body}
    </svg>
  );
};
